'use client';

import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
    PinterestShareButton,
    RedditShareButton,
    FacebookIcon,
    XIcon,
    LinkedinIcon,
    WhatsappIcon,
    PinterestIcon,
    RedditIcon,
} from 'react-share';

const ICON_SIZE = 32;
const ICON_ROUND = true;

export interface BlogShareButtonsProps {
    /** Full URL to share (e.g. https://site.com/blogs/slug) or path (e.g. /blogs/slug) — path is resolved with window.location.origin on client */
    shareUrl: string;
    /** Optional title for the shared content */
    title?: string;
    /** Optional image URL for Pinterest (required for Pinterest share to work) */
    media?: string;
    /** Optional class for the container */
    className?: string;
}

function getFullUrl(url: string): string {
    if (typeof window === 'undefined') return url;
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    return `${window.location.origin}${url.startsWith('/') ? url : `/${url}`}`;
}

export default function BlogShareButtons({ shareUrl, title = '', media, className = '' }: BlogShareButtonsProps) {
    const fullUrl = getFullUrl(shareUrl);

    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <FacebookShareButton url={fullUrl}>
                <FacebookIcon size={ICON_SIZE} round={ICON_ROUND} />
            </FacebookShareButton>
            <TwitterShareButton url={fullUrl} title={title}>
                <XIcon size={ICON_SIZE} round={ICON_ROUND} />
            </TwitterShareButton>
            <LinkedinShareButton url={fullUrl} title={title}>
                <LinkedinIcon size={ICON_SIZE} round={ICON_ROUND} />
            </LinkedinShareButton>
            <WhatsappShareButton url={fullUrl} title={title}>
                <WhatsappIcon size={ICON_SIZE} round={ICON_ROUND} />
            </WhatsappShareButton>
            {media && (
                <PinterestShareButton url={fullUrl} media={media} description={title}>
                    <PinterestIcon size={ICON_SIZE} round={ICON_ROUND} />
                </PinterestShareButton>
            )}
            <RedditShareButton url={fullUrl} title={title}>
                <RedditIcon size={ICON_SIZE} round={ICON_ROUND} />
            </RedditShareButton>
        </div>
    );
}
